import * as React from "react";
const SvgFiRrLetterCase = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M7.4 5.553a1.04 1.04 0 0 0-1.79 0l-5.5 11a1 1 0 1 0 1.79.894L3.619 14h5.764l1.724 3.447a1 1 0 0 0 1.345.455 1 1 0 0 0 .444-1.349zM4.619 12l1.88-3.764L8.384 12zM23 8a1 1 0 0 0-1 1v.026A4.95 4.95 0 0 0 19 8a5 5 0 1 0 0 10 4.95 4.95 0 0 0 3-1.026V17a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 8a3 3 0 1 1 0-5.999A3 3 0 0 1 19 16"
    />
  </svg>
);
export default SvgFiRrLetterCase;
